import gql from 'graphql-tag';

export const deleteRoleAssignmentsMutation = gql`
  mutation deleteRoleAssignments($resourceId: String!, $assignmentIds: [String]!) {
    deleteRoleAssignments(resourceId: $resourceId, assignmentIds: $assignmentIds) {
      resourceRoleAssignmentId
      isPrivate
      user {
        userId
      }
      team {
        teamId
      }
    }
  }
`;

const deleteRoleAssignments = () => ({
  mutation: deleteRoleAssignmentsMutation,
  module: 'users',
  buildVariables: (
  {
    resourceId,
    assignmentIds
  }) => ({
    resourceId,
    assignmentIds
  })
});

export default deleteRoleAssignments;